/**
 * Vendor core desde yarn → window.
 * Usa `jquery` (3.x), el mismo singleton que `import $ from 'jquery'` en Vue/Stimulus
 * y que login/print.
 *
 * Carga dinámica: los UMD exigen window.jQuery antes de evaluarse.
 * Escritura en window solo vía @/legacy/registry.
 */
import jQuery from 'jquery';
import _ from 'lodash';
import moment from 'moment';
import Backbone from 'backbone';
import Radio from 'backbone.radio';
import Marionette from 'backbone.marionette';

import {
  registerBackbone,
  registerJquery,
  registerLodash,
  registerMoment,
  syncGlobalsFromWindow,
} from '@/legacy/registry';

export async function loadVendorYarnCore() {
  registerJquery(jQuery);
  registerLodash(_);
  registerMoment(moment);
  registerBackbone(Backbone, { Radio, Marionette });

  const { default: cargarBackboneSyphon } = await import(
    '@/legacy/umd/cargar_backbone_syphon'
  );
  await cargarBackboneSyphon();

  await import('jquery-ujs');

  const { default: cargarSelect2 } = await import('@/legacy/umd/cargar_select2');
  await cargarSelect2();

  const { default: cargarToastr } = await import('@/legacy/umd/cargar_toastr');
  await cargarToastr();

  await import('sweetalert');

  syncGlobalsFromWindow();
}
